import { Container, Text, Trust } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import type { WithMetadata } from "../../pages";
import type { PreFooterProps } from "./types";
import { InsuranceBenefits } from "./InsuranceBenefits";
import { LogoFooterShield } from "./LogoFooterShield";
import "./PreFooter.css";

export const PreFooter = ({ ref, ...props }: WithMetadata<PreFooterProps>) => {
  const { componentName, ...otherProps } = props;

  const classes = classNames(
    "mobius",
    "mobius-pre-footer",
    otherProps.className,
  );
  const { variant } = otherProps;
  const isMinimal = variant === "minimal";

  return (
    <>
      {!isMinimal && <InsuranceBenefits />}
      <div
        ref={ref}
        {...otherProps}
        {...(componentName ? { "data-component": componentName } : {})}
        {...(variant ? { "data-variant": variant } : {})}
        className={classes}
      >
        <Container size="sm" className="mobius-pre-footer__content">
          <Trust
            locale="en-US"
            variant="micro-combo"
            theme="dark"
            className="mobius-pre-footer__widget"
          />
          <LogoFooterShield />
          <Text className="mobius-pre-footer__text">
            Insuring over 1 million small business owners worldwide.
          </Text>
        </Container>
      </div>
    </>
  );
};

PreFooter.displayName = "PreFooter";
